// Keyboard movement for composite widgets that keep one item in the tab order
// (tabs, the stocks grid's filter listbox): arrows step and wrap, Home and End
// jump to the ends.

export type Orientation = "horizontal" | "vertical";

/**
 * The index a key moves focus to among `count` items, or null when the key is
 * not a movement key for this orientation (the caller lets it through).
 */
export function rovingIndex(key: string, current: number, count: number, orientation: Orientation): number | null {
  if (count <= 0) return null;
  const back = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
  const forward = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
  const from = Math.min(Math.max(current, 0), count - 1);
  if (key === forward) return (from + 1) % count;
  if (key === back) return (from - 1 + count) % count;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  return null;
}
